import { Rx } from "subtree.js/core";

export interface RegisterDraft {
  readonly name: string;
  readonly email: string;
  readonly password: string;
}

export class RegisterState {
  readonly draft = new Rx<RegisterDraft>({ name: "", email: "", password: "" });
  readonly error = new Rx<string | null>(null);
  readonly busy = new Rx(false);
}

export abstract class RegisterActions {
  abstract setName(value: string): void;
  abstract setEmail(value: string): void;
  abstract setPassword(value: string): void;
  abstract submit(): Promise<void>;
  abstract continueWithGoogle(): Promise<void>;
  abstract continueWithApple(): Promise<void>;
}
